/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Step_CooldownInputs */

const en_coach_step_cooldown = /** @type {(inputs: Coach_Step_CooldownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cool-down`)
};

const de_coach_step_cooldown = /** @type {(inputs: Coach_Step_CooldownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auslaufen`)
};

/**
* | output |
* | --- |
* | "Cool-down" |
*
* @param {Coach_Step_CooldownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_step_cooldown = /** @type {((inputs?: Coach_Step_CooldownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Step_CooldownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_step_cooldown(inputs)
	return de_coach_step_cooldown(inputs)
});